import { render, staticRenderFns } from "./getLock.vue?vue&type=template&id=2a218e5c&scoped=true&"
import script from "./getLock.vue?vue&type=script&lang=js&"
export * from "./getLock.vue?vue&type=script&lang=js&"
import style0 from "./getLock.vue?vue&type=style&index=0&id=2a218e5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a218e5c",
  null
  
)

export default component.exports